import { render } from "./InDel_Protein.vue?vue&type=template&id=265ac23b"
import script from "./InDel_Protein.vue?vue&type=script&lang=js"
export * from "./InDel_Protein.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__